"use client";

import React, {FC} from "react";
import {AlertCircle, AlertTriangle, CheckCircle, X} from "lucide-react";
import {Button} from "@/shared/components/ui/button";
import {AlertPopupProps} from "./AlertPopup.types";
import {
    alertBodyStyles,
    alertCancelButtonStyles,
    alertCloseButtonStyles,
    alertConfirmButtonStyles,
    alertFooterStyles,
    alertIconStyles,
    alertPopupStyles,
    alertTitleStyles,
} from "./AlertPopup.styles";

export const AlertPopup: FC<AlertPopupProps> = ({
    title,
    description,
    type = "error",
    onClose,
    onConfirm,
    confirmLabel = "Tak",
    cancelLabel = "Nie",
}) => {
    const isConfirmType = type === "delete-confirm" || type === "confirm";
    const hasConfirmHandler = onConfirm !== undefined;

    const Icon =
        type === "success"
            ? CheckCircle
            : type === "warning" || type === "delete-confirm" || type === "confirm"
                ? AlertTriangle
                : AlertCircle;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50">
            <div className={alertPopupStyles({variant: type})}>
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <Icon className={alertIconStyles({variant: type})}/>
                        <h3 className={alertTitleStyles({variant: type})}>{title}</h3>
                    </div>
                    <button
                        onClick={onClose}
                        className={alertCloseButtonStyles()}
                        aria-label="Zamknij"
                    >
                        <X className="w-5 h-5"/>
                    </button>
                </div>

                <div className={alertBodyStyles()}>
                    {typeof description === "string" ? <p>{description}</p> : description}
                </div>

                <div className={alertFooterStyles()}>
                    {isConfirmType && hasConfirmHandler ? (
                        <>
                            <Button
                                onClick={() => {
                                    onConfirm();
                                    onClose();
                                }}
                                variant="outline"
                                className={alertCancelButtonStyles()}
                            >
                                {confirmLabel}
                            </Button>
                            <Button
                                onClick={onClose}
                                variant="ghost"
                                className={alertConfirmButtonStyles({variant: type})}
                            >
                                {cancelLabel}
                            </Button>
                        </>
                    ) : (
                        <Button
                            onClick={onClose}
                            variant="outline"
                            className={alertCancelButtonStyles()}
                        >
                            OK
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

